import React from "react";
import SessionView from "../components/pages/Content/SessionView";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const SessionViewLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{margin: "70px 0px 0px 200px", width: "100%"}}>
        <SessionView />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default SessionViewLayout;